module.exports = __webpack_public_path__ + "static/media/Intruded tooth 11.ed2bb6f7.png";